import { render, staticRenderFns } from "./_weightAuditor.vue?vue&type=template&id=5b69edb2&scoped=true&"
import script from "./_weightAuditor.vue?vue&type=script&lang=js&"
export * from "./_weightAuditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b69edb2",
  null
  
)

export default component.exports